import { render } from "./MaterialIcon.vue?vue&type=template&id=a176c6a2&ts=true"
import script from "./MaterialIcon.vue?vue&type=script&lang=ts"
export * from "./MaterialIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__